import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
    selector: '[appToFixedFormatter]',
    standalone: false
})
export class ToFixedFormatterDirective {
  @Input('appToFixedFormatter') decimalPlaces: number = 2;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue)) {
      const formattedValue = numericValue.toFixed(this.decimalPlaces);
      this.el.nativeElement.value = formattedValue;
    }
  }
}
